import React, { useContext, useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Badge } from "primereact/badge";
import { UserDelimitation } from "../users/UserDelimitation";
import { applicationsService } from "../../services/ApplicationsService";
import "./dashboard.scss";
import { AppDB } from "../../App";
import { useHistory } from "react-router-dom";
import { Fieldset } from "primereact/fieldset";
import { useIsAuthenticated } from "@azure/msal-react";
import { authenticationService } from "../../services/AuthenticationService";
export const Dashboard = (props) => {
	const [delimitation, setDelimitation] = useState({ delimitationID: "", delimitationLevelID: "" });
	var { finalUserMenu,setReturnedApplication } = useContext(AppDB);
	const { setGlobalDelimitation, globalDelimitation, activeTabIndex, setActiveTabIndex ,returnedApplication} = useContext(AppDB);
	var [mapping, setMapping] = useState({});
	var [data, setData] = useState({
		all: {
			registrations: {
				passed: 0,
				failed: 0,
				rejected: 0,
				approved: 0
			},
			migrations: {
				passed: 0,
				failed: 0,
				rejected: 0,
				approved: 0
			},
			amendments: {
				passed: 0,
				failed: 0,
				rejected: 0,
				approved: 0
			},
			transfers: {
				pending: 0,
				rejected: 0,
				approved: 0
			},
			removals: {
				pending: 0,
				rejected: 0,
				approved: 0
			},
			reinstatements: {
				pending: 0,
				rejected: 0,
				approved: 0
			},
			suspensions: {
				pending: 0,
				rejected: 0,
				approved: 0
			},
			objections: {
				pending: 0,
				rejected: 0,
				approved: 0
			},
			corrections: {
				pending: 0,
				rejected: 0,
				approved: 0
			}
		},
		unassisted: {
			registrations: {
				new: 0,
				rejected: 0
			},
			amendments: {
				new: 0,
				rejected: 0
			}
		}
	});
	var [loading, setLoading] = useState(false);

	useEffect(() => {
		var tempObj = {};
		var menu = finalUserMenu?.routes || {};
		console.log(menu)
		Object.keys(menu).forEach((route) => {
			tempObj[route] = true;
		});

		if ("/applications/amendments" in menu) {
			mapping["central_amendment"] = "/applications/amendments";
		}

		if ("/applications/registrations" in menu) {
			mapping["central_registration"] = "/applications/registrations";
		}

		if ("/applications/migrations" in menu) {
			mapping["central_migration"] = "/applications/migrations";
		}


		if ("/applications/transfers" in menu) {
			mapping["central_transfer"] = "/applications/transfers";
		}

		if ("/applications/removals" in menu) {
			mapping["central_removals"] = "/applications/removals";
		}

		if ("/applications/suspensions" in menu) {
			mapping["central_suspensions"] = "/applications/suspensions";
		}

		if ("/applications/reinstatements" in menu) {
			mapping["central_reinstatements"] = "/applications/reinstatements";
		}
		
		if ("/applications/corrections" in menu) {
			mapping["central_corrections"] = "/applications/corrections";
		}

		if ("/objections" in menu) {
			mapping["central_objections"] = "/objections";
		}
		

		if ("/applications/unassisted/amendments" in menu) {
			mapping["unassisted_amendment"] = "/applications/unassisted/amendments";
		}
		if ("/applications/unassisted/registrations" in menu) {
			mapping["unassisted_registration"] = "/applications/unassisted/registrations";
		}

		// setMapping({ ...mapping });
		setMapping((prevMapping) => ({ ...prevMapping }));
		setGlobalDelimitation({ dashboard: true });
		getUserInfo()
	}, []);

	useEffect(() => {
		if (delimitation.delimitationID != "") {
			setLoading(true);

			const params = {
				delimitationID: delimitation.delimitationID,
				delimitationLevelID: delimitation.delimitationLevelID
			};

			applicationsService
				.getStats(params)
				.then((data) => {
					setLoading(false);
					setData(data);
				})
				.catch((error) => {
					setLoading(false);
					console.error("Error fetching stats:", error);
				});
		}
	}, [delimitation]);

	useEffect(() => {
		setReturnedApplication(false);
	}, [returnedApplication]);


	var history = useHistory();
	const handleNavigation = (module, tabIndex) => {
		console.log(module)
		setGlobalDelimitation({ ...globalDelimitation, activeTabIndex: tabIndex });
		setActiveTabIndex(tabIndex)
		history.replace(mapping[module] + "?do-not-clear-delimitations");
		//check user modules modules
		//set delimiation,tab
		//route
	};
	const isAuthenticated = useIsAuthenticated();
	console.log("Authentication status :",isAuthenticated)

	const getUserInfo =async()=>{
		if (isAuthenticated) {
			var loggedIn = await authenticationService.login();
			console.log(loggedIn)
			if (loggedIn.status) {
				return loggedIn
			} 
	}
}
// 	//Implementation for returned applications
// 	 document.querySelectorAll("span").forEach(span => {

//     if (span.textContent=== "Returned") {
//       console.log("Returned Clicked");
// 	  setReturnedApplication(true)
//     }
//   });

	return (
		<div className="p-m-4 dashboard">
			<h1>Dashboard</h1>
			{/* <Corrections/> */}
			<div className="mb-4">
				<UserDelimitation
					isExteral={true}
					makeDashboardTrigger={true}
					showVillage={false}
					showFilter={true}
					onDelimitationChanged={(delimitation) => setDelimitation(delimitation)}
				/>
			</div>

			{/* Overview Section */}
			{("central_registration" in mapping ||
				"central_migration" in mapping ||
				"central_amendment" in mapping ||
				"central_transfer" in mapping ||
				"central_removals" in mapping ||
				"central_suspensions" in mapping ||
				"central_reinstatements" in mapping ||
				"central_objections" in mapping) && (
					<>
						<Fieldset legend="All Channels" className="h-100">
							<div className="card-containe grid">
								{/* Registrations Card */}

								{"central_registration" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4">
										<Card title="Registrations" className="p-card">
											<p>
												<span>New(Queued)</span>
												<Badge
													className="p-badge"
													value={data.all.registrations?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_registration", 0)}
												/>
											</p>
											<p>
												<span>Returned</span>
												<Badge
													className="p-badge"
													value={data?.all?.registrations?.referred || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_registration", 1)}
												/>
											</p>
											<p>
												<span>Passed</span>
												<Badge
													className="p-badge"
													value={data.all.registrations?.passed || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_registration", 2)}
												/>
											</p>
											<p>
												<span>Failed</span>
												<Badge
													className="p-badge"
													value={data.all.registrations?.failed || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_registration", 3)}
												/>
											</p>
											<p>
												<span>Approved</span>
												<Badge
													className="p-badge"
													value={data.all.registrations?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_registration", 4)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data.all.registrations.rejected}
													severity="secondary"
													onClick={() => handleNavigation("central_registration", 5)}
												/>
											</p>
										</Card>
									</div>
								)}

								{/* Migrations Card */}
								{"central_migration_" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4">
										<Card title="Migrations" className="p-card">
											<p>
												<span>New(Queued)</span>
												<Badge
													className="p-badge"
													value={data?.all?.migrations?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_migration", 0)}
												/>
											</p>
											<p>
												<span>Passed</span>
												<Badge
													className="p-badge"
													value={data?.all?.migrations?.passed || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_migration", 1)}
												/>
											</p>
											<p>
												<span>Failed</span>
												<Badge
													className="p-badge"
													value={data?.all?.migrations?.failed || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_migration", 2)}
												/>
											</p>
											<p>
												<span>Approved</span>
												<Badge
													className="p-badge"
													value={data?.all?.migrations?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_migration", 3)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data?.all?.migrations?.rejected || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_migration", 4)}
												/>
											</p>
										</Card>
									</div>
								)}

								{/* Amendments Card */}
								{"central_amendment" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4">
										<Card title="Amendments" className="p-card">
											<p>
												<span>New(Queued)</span>
												<Badge
													className="p-badge"
													value={data.all.amendments?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_amendment", 0)}
												/>
											</p>
											<p>
												<span>Returned</span>
												<Badge
													className="p-badge"
													value={data?.all?.amendments?.referred || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_amendment", 1)}
												/>
											</p>
											<p>
												<span>Passed</span>
												<Badge
													className="p-badge"
													value={data.all.amendments?.passed || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_amendment", 2)}
												/>
											</p>
											<p>
												<span>Failed</span>
												<Badge
													className="p-badge"
													value={data.all.amendments?.failed || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_amendment", 3)}
												/>
											</p>
											<p>
												<span>Approved</span>
												<Badge
													className="p-badge"
													value={data.all.amendments?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_amendment", 4)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data.all.amendments?.rejected || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_amendment", 4)}
												/>
											</p>
										</Card>
									</div>
								)}
								{/* Transfers Card */}
								{"central_transfer" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4 ">
										<Card title="Transfers" className="p-card " style={{ boxShadow: "none" }}>
											<p>
												<span>New(Queued)</span>
												<Badge
													className="p-badge"
													value={data.all.transfers?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_transfer", 0)}
												/>
											</p>
											<p>
												<span>Returned</span>
												<Badge
													className="p-badge"
													value={data?.all?.transfers?.referred || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_transfer", 1)}
												/>	</p>
											<p>
												<span>Pending</span>
												<Badge
													className="p-badge"
													value={data.all.transfers?.pending || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_transfer", 2)}
												/>
											</p>
											<p>
												<span>Approved</span>
												<Badge
													className="p-badge"
													value={data.all.transfers?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_transfer", 3)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data.all.transfers?.rejected || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_transfer", 4)}
												/>
											</p>
										</Card>
									</div>
								)}
								{"central_removals" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4 ">
										<Card title="Removals" className="p-card " style={{ boxShadow: "none" }}>
											<p>
												<span>New(Queued)</span>
												<Badge
													className="p-badge"
													value={data.all.removals?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_removals", 0)}
												/>
											</p>

											<p>
												<span>Returned</span>
												<Badge
													className="p-badge"
													value={data?.all?.removals?.referred || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_removals", 1)}
												/>	</p>
											<p>
												<span>Pending</span>
												<Badge
													className="p-badge"
													value={data?.all?.removals?.pending || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_removals", 2)}
												/>
											</p>

											<p>
												<span>Approved</span>
												<Badge
													className="p-badge"
													value={data?.all?.removals?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_removals", 3)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data?.all?.removals?.rejected || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_removals", 4)}
												/>
											</p>
										</Card>
									</div>
								)}
								{"central_suspensions" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4 ">
										<Card title="Suspensions" className="p-card " style={{ boxShadow: "none" }}>
											<p>
												<span>New(Queued)</span>
												<Badge
													className="p-badge"
													value={data.all.suspensions?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_suspensions", 0)}
												/>
											</p>
											<p>
												<span>Returned</span>
												<Badge
													className="p-badge"
													value={data?.all?.suspensions?.referred || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_suspensions", 1)}
												/>	</p>
											<p>
												<span>Pending</span>
												<Badge
													className="p-badge"
													value={data?.all?.suspensions?.pending || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_suspensions", 0)}
												/>
											</p>

											<p>
												<span>Approved</span>
												<Badge
													className="p-badge"
													value={data?.all?.suspensions?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_suspensions", 3)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data?.all?.suspensions?.rejected || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_suspensions", 4)}
												/>
											</p>
										</Card>
									</div>
								)}
								{"central_reinstatements" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4 ">
										<Card title="Re-Instatements" className="p-card " style={{ boxShadow: "none" }}>
											<p>
												<span>New(Queued)</span>
												<Badge
													className="p-badge"
													value={data.all.reinstatements?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_reinstatements", 0)}
												/>
											</p>
											<p>
												<span>Returned</span>
												<Badge
													className="p-badge"
													value={data?.all?.reinstatements?.referred || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_reinstatements", 1)}
												/>	</p>
											<p>
												<span>Pending</span>
												<Badge
													className="p-badge"
													value={data?.all?.reinstatements?.pending || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_reinstatements", 2)}
												/>
											</p>

											<p>
												<span>Approved</span>
												<Badge
													className="p-badge"
													value={data?.all?.reinstatements?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_reinstatements", 2)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data?.all?.reinstatements?.rejected}
													severity="secondary"
													onClick={() => handleNavigation("central_reinstatements", 3)}
												/>
											</p>
										</Card>
									</div>
								)}
								{"central_objections" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4 ">
										<Card title="Objections" className="p-card " style={{ boxShadow: "none" }}>
											<p>
												<span>New(Queued)</span>
												<Badge
													className="p-badge"
													value={data?.all?.objections?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_objections", 0)}
												/>
											</p>
											<p>
												<span>Pending</span>
												<Badge
													className="p-badge"
													value={data?.all?.objections?.pending || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_objections", 1)}
												/>
											</p>
											<p>
												<span>Approved</span>
												<Badge
													className="p-badge"
													value={data?.all?.objections?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_objections", 2)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data?.all?.objections?.rejected || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_objections", 3)}
												/>
											</p>
										</Card>
									</div>
								)}
									{"central_corrections" in mapping && (
									<div className="card-item  col-12 md:col-6 lg:col-4">
										<Card title="Corrections" className="p-card">
											<p>
												<span>Pending</span>
												<Badge
													className="p-badge"
													value={data.all.corrections?.new || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_corrections", 0)}
												/>
											</p>
											<p>
												<span>Passed</span>
												<Badge
													className="p-badge"
													value={data?.all?.corrections?.approved || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_corrections", 1)}
												/>
											</p>
											<p>
												<span>Rejected</span>
												<Badge
													className="p-badge"
													value={data.all.corrections?.rejected || 0}
													severity="secondary"
													onClick={() => handleNavigation("central_corrections", 2)}
												/>
											</p>
										
										</Card>
									</div>
								)}
								
							</div>
						</Fieldset>
					</>
				)}
			

			{("unassisted_amendment" in mapping || "unassisted_registration" in mapping) && (
				<>
					<br />
					<Fieldset legend="Self Service Checks" className="h-100">
						<div className="card-containe grid">
							{"unassisted_amendment" in mapping && (
								<div className="card-item    col-12 md:col-6 lg:col-4">
									<Card title="Amendments" className="p-card">
										<p>
											<span>Pending</span>
											<Badge
												className="p-badge"
												value={data.unassisted.amendments?.new || 0}
												severity="secondary"
												onClick={() => handleNavigation("unassisted_amendment", 0)}
											/>
										</p>
										<p>
											<span>Rejected</span>
											<Badge
												className="p-badge"
												value={data.unassisted.amendments?.rejected || 0}
												severity="secondary"
												onClick={() => handleNavigation("unassisted_amendment", 1)}
											/>
										</p>
										<p>
											<span>Total Amendments</span>
											<Badge
												className="p-badge"
												value={data.unassisted.amendments?.totalUnAssistedAmendments || 0}
												severity="success"
											/>
										</p>
										
									</Card>
								</div>
							)}
							{"unassisted_registration" in mapping && (
								<div className="card-item   col-12 md:col-6 lg:col-4">
									<Card title="Registrations" className="p-card">
										<p>
											<span>Pending</span>
											<Badge
												className="p-badge"
												value={data.unassisted.registrations?.new || 0}
												severity="secondary"
												onClick={() => handleNavigation("unassisted_registration", 0)}
											/>
										</p>
										<p>
											<span>Rejected</span>
											<Badge
												className="p-badge"
												value={data.unassisted.registrations?.rejected || 0}
												severity="secondary"
												onClick={() => handleNavigation("unassisted_registration", 1)}
											/>
										</p>
											<p>
											<span>Total Registrations</span>
											<Badge
												className="p-badge"
												value={data.unassisted.registrations?.totalUnAssistedRegistrations || 0}
												severity="success"
											/>
										</p>
									</Card>
								</div>
							)}
						</div>
					</Fieldset>
				</>
			)}

			{("central_migration_" in mapping) && (
				<>
					<br />
					<Fieldset legend="Migrations" className="h-100">
						<div className="card-item   col-12 md:col-6 lg:col-4">
							<Card title="" className="p-card " style={{ boxShadow: "none" }}>
								<p>
									<span>Migrated Records</span>
									<Badge
										className="p-badge"
										value={data?.all?.migrations?.migratedRecords || 0}
										severity="secondary"
										onClick={() => handleNavigation("central_migration", 0)}
									/>
								</p>
								<p>
									<span>Migrated Applications</span>
									<Badge
										className="p-badge"
										value={data?.all?.migrations?.migratedApplications || 0}
										severity="secondary"
										onClick={() => handleNavigation("central_migration", 0)}
									/>
								</p>
								<p>
									<span>Accepted MOHA</span>
									<Badge
										className="p-badge"
										value={data?.all?.migrations?.acceptedMoha || 0}
										severity="secondary"
										onClick={() => handleNavigation("central_migration", 0)}
									/>
								</p>
								<p>
									<span>Rejected MOHA</span>
									<Badge
										className="p-badge"
										value={data?.all?.migrations?.rejectedMoha || 0}
										severity="secondary"
										onClick={() => handleNavigation("central_migration", 0)}
									/>
								</p>
								<p>
									<span>Migrated Electors</span>
									<Badge
										className="p-badge"
										value={data?.all?.migrations?.migratedElectors || 0}
										severity="secondary"
										onClick={() => handleNavigation("central_migration", 0)}
									/>
								</p>
							</Card>
						</div>
					</Fieldset>
				</>)}
		</div>
	);
};
